import { ClusterProperties } from "./types";

type ClusterPointFeature = GeoJSON.Feature<GeoJSON.Point, ClusterProperties>

export  const isClusterPointFeature = (obj: unknown): obj is ClusterPointFeature => {
   const clusterObject = obj as ClusterPointFeature;
   return clusterObject?.geometry?.type === "Point" && clusterObject?.properties?.cluster_id !== undefined;
}